export const cvs = state => state.cvs

export const cv = state => state.cv

export const rate = state => state.rate

export const sortAry = state => state.sortAry

export const pageIndex = state => state.pageIndex

export const recommendTeamplate = state => state.recommendTeamplate

export const profiles = state => state.profiles

export const others = state => state.others